/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { useFormState } from 'react-final-form';
import { FormValues } from 'types';
import { get } from 'lodash-es';

export const Control: React.FC<any> = ({ className = '', name, ...rest }) => {
  const { touched, errors } = useFormState<FormValues>();
  const isTouched = get(touched, name);
  const error = get(errors, name);

  return (
    <FormControl
      {...rest}
      className={className}
      isInvalid={error && isTouched}
    />
  );
};

export const MetaError: React.FC<{ name: string }> = ({ name }) => {
  const { errors } = useFormState<FormValues>();

  const error = get(errors, name);

  return <FormErrorMessage>{error}</FormErrorMessage>;
};
